import HomeCarousel from '../../../components/homeCarousel/homeCarousel';
import MobileCarouselCom from '../../../components/mobCarousel/MobileCarousel';
import { destinationData } from '../../../dummyData/destinationData';
import './destination.css';

const DestinationSection = () => {
    return (
        <>
            <div className='destinationBg' />
            <div className='destinationSection customContainer' id='destinationSection'>
                <div className='alignCenter mobCenter'>
                    <div>
                        <p className='pageCount'>Journey Junction</p>
                        <p className='homeTitle'>Explore Real Adventure</p>
                    </div>
                </div>
                <div className='mobHidden'>
                    <HomeCarousel data={destinationData.slice(0, 12)} />
                </div>
                <div className='mobDisplay'>
                    <MobileCarouselCom type='type' data={destinationData.slice(0, 12)} />
                </div>
            </div>
        </>
    );
};

export default DestinationSection;
